import React, {useState} from 'react';

import BenchlingConfig from 'BenchlingConfig';

import GenerativeModelForm from './GenerativeModelForm';
import {BoltzGenTargetType} from './GenerativeModelsConstants';
import GenerativeModelsRunsList from './GenerativeModelsRunsList';

enum GenerativeModelsViewType {
  FORM = 'FORM',
  RUNS_LIST = 'RUNS_LIST',
}

interface GenerativeModelsViewProps {
  currentEntityType: BoltzGenTargetType;
  targetId: string;
}

export default function GenerativeModelsView({
  currentEntityType,
  targetId,
}: GenerativeModelsViewProps): JSX.Element | null {
  const [currentView, setCurrentView] = useState<GenerativeModelsViewType>(GenerativeModelsViewType.FORM);

  if (!BenchlingConfig.MODEL_HUB_ENABLE_GENERATIVE_MODELS_TAB) {
    return <div>Generative models are not enabled</div>;
  }

  switch (currentView) {
    case GenerativeModelsViewType.FORM:
      return (
        <GenerativeModelForm
          currentEntityType={currentEntityType}
          targetId={targetId}
          navigateToList={() => {
            setCurrentView(GenerativeModelsViewType.RUNS_LIST);
          }}
        />
      );
    case GenerativeModelsViewType.RUNS_LIST:
      return (
        <GenerativeModelsRunsList
          onCreateNewRun={() => {
            setCurrentView(GenerativeModelsViewType.FORM);
          }}
        />
      );
    default:
      return null;
  }
}
